import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
    aluguelPesquisa: {
      status: "APROVADO",
      dataInicio: undefined,
      dataFim: undefined,
      imovel: {
        idNaImobiliaria: undefined,
        endereco: undefined
      },
      locatario: {
        nome: undefined
      },
      proprietario: {
        nome: undefined
      },
      tipoAluguel: undefined,
      tipoGarantia: undefined,
      pagina: 0
    },
    aluguelSelecionado: {
      id: 0,
      usuario: { id: 0 },
      imovel:{ id: 0, endereco: '',
        bairro: { id: 0, nome: '' },
        cidade: { id: 0, nome: '' }, 
      },
      locatario: { id: 0, nome: '' },
      proprietario: { id: 0, nome: '' },
      dataInicio: undefined,
      dataPrimeiroVencimento: undefined,
      contaBancariaImobiliaria: { id: 0, nome: ''},
      fiadores: [],
      contasBancariasRepasse: [],
      primeiroMesSerie: 1
    },
    listaAlugueis:[],
    formularios: [],
    logs: [],
    fiadorSelecionado: {},
    usuariosDisponiveis: [],
    clientesDisponiveis: [],
    imoveisDisponiveis: [],
    clientesContrato: [],
    boletosAvulsos: [],

    labelQuantidade: ''
}

const mutations = {
  novoAluguel(state) {
    state.aluguelSelecionado = {
      id: 0,
      usuario: { id: 0, nome: '' },
      imovel:{ id: 0, endereco: '',
        bairro: { id: 0, nome: '' },
        cidade: { id: 0, nome: '' }, 
      },
      locatario: { id: 0, nome: '' },
      proprietario: { id: 0, nome: '' },
      dataInicio: undefined,
      dataPrimeiroVencimento: undefined,
      contaBancariaImobiliaria: { id: 0, nome: ''},
      fiadores: [],
      contasBancariasRepasse: [],
      primeiroMesSerie: 1
    };
    state.fiadorSelecionado = {};
    state.logs = [];
    state.formularios = [];
    state.usuariosDisponiveis = [];
    state.clientesDisponiveis = [];
    state.imoveisDisponiveis = [];
    state.clientesContrato = []
  },
  configurarParametros(state,payload){
    let parametros = payload

    state.aluguelSelecionado = {
      ...state.aluguelSelecionado,
      formaAluguel: parametros.formaAluguel,
      duracao: parametros.duracao,
      reajuste: parametros.reajuste,
      indiceReajuste: parametros.indiceReajuste,
      multa: parametros.multa,
      diasMulta: parametros.diasMulta,
      mora: parametros.mora,
      diasMora: parametros.diasMora,
      permanenciaDiaria: parametros.permanenciaDiaria,
      diasPermanenciaDiaria: parametros.diasPermanenciaDiaria,
      honorariosAdvocaticios: parametros.honorariosAdvocaticios,
      diasHonorariosAdvocaticios: parametros.diasHonorariosAdvocaticios,
      despesasCobrancas: parametros.despesasCobrancas,
      diasDespesasCobrancas: parametros.diasDespesasCobrancas, 
      comissao: parametros.comissao,
      comissao1oMes: parametros.comissao1oMes,
      regraRepasse: parametros.regraRepasse,
      carenciaRepasse: parametros.carenciaRepasse,
      mesesMultaRescisao: parametros.mesesMultaRescisao
    }
  },
  limparAluguelPesquisa(state) {
    state.aluguelPesquisa = {
      status: undefined,
      dataInicio: undefined,
      dataFim: undefined,
      imovel: {
        idNaImobiliaria: undefined,
        endereco: undefined
      },
      locatario: {
        nome: undefined
      },
      proprietario: {
        nome: undefined
      },
      tipoAluguel: undefined,
      tipoGarantia: undefined,
      pagina: 0
    }
  },
  limparAlugueisListados(state) {
    state.listaAlugueis = [];
  },
  atualizarContasRepasse(state, contaBancaria) {
    state.aluguelSelecionado.contasBancariasRepasse.forEach(item => {
      if(item.proprietarioBeneficiario.id === contaBancaria.cliente.id){
        item.contaBancaria = contaBancaria
      }
    });
  },
  atualizarListaAlugueis(state, payload) {
    if(state.aluguelPesquisa.pagina == 0) {
      state.listaAlugueis = payload.lista;
    } else {
      state.listaAlugueis.push(...payload.lista);
    }
    state.labelQuantidade = payload.quantidade + (payload.quantidade == 1 ? " contrato encontrado" : " contratos encontrados");
  },
  atualizarAluguelSelecionado(state, payload) {
    state.aluguelSelecionado = payload;
    state.usuariosDisponiveis = [payload.usuario];
    state.clientesDisponiveis = [payload.locatario];
    state.imoveisDisponiveis = [payload.imovel];
    state.clientesContrato = []
  },
  atualizarClienteAluguelSelecionado(state, payload) {
    state.aluguelSelecionado.locatario = payload;
    state.clientesDisponiveis = [payload];
  },
  atualizarFiadorAluguelSelecionado(state, payload) {
    state.fiadorSelecionado = payload;
    state.clientesDisponiveis = [payload];
  },
  atualizarUsuariosDisponiveis(state, payload) {
    state.usuariosDisponiveis = payload
  },
  atualizarClientesDisponiveis(state, payload) {
    state.clientesDisponiveis = payload
  },
  atualizarImoveisDisponiveis(state, payload) {
    const imoveisDisponiveis = payload.filter(imovel => imovel.status === 'DISPONIVEL');
    state.imoveisDisponiveis = [...imoveisDisponiveis];
  },
  atualizarClientesContrato(state, payload) {
    state.clientesContrato = payload.clientesContrato
  },
  atualizarFormularios(state, payload) {
    state.formularios = payload;
  },
  atualizarArquivos(state, payload) {
    state.aluguelSelecionado.diretorios = payload;
  },
  atualizarLogs(state, payload) {
    state.logs = payload;
  },
  atualizarBoletosAvulsos(state, payload) {
    state.boletosAvulsos = payload
  }
}

const actions = {
  //ALUGUEL
  novoAluguel(context) {
    context.commit('novoAluguel');
  },
  configurarParametros(context, payload) {
    context.commit('configurarParametros', payload);
  },
  limparAluguelPesquisa(context) {
    context.commit("limparAluguelPesquisa");
  },
  limparAlugueisListados(context) {
    context.commit("limparAlugueisListados");
  },
  atualizarContasRepasse(context, payload) {
    context.commit("atualizarContasRepasse", payload);
  },
  listarAlugueis(context, payload) {
    return axios.post(URLS.ALUGUEIS_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaAlugueis', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarAlugueis', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_GRAVAR, context.state.aluguelSelecionado)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  alterarDataReajuste(context, payload) {
    return axios.post(URLS.ALUGUEIS_ALTERAR_DATA_REAJUSTE, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('alterarDataReajuste', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  desfazerAlteracaoDataReajuste(context, payload) {
    return axios.post(URLS.ALUGUEIS_DESFAZER_ALTERACAO_DATA_REAJUSTE, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('desfazerAlteracaoDataReajuste', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_REMOVER, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          response.data.item ? context.commit('atualizarAluguelSelecionado', response.data.item) : context.commit('novoAluguel') ; 
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  desarquivarAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_DESARQUIVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('desarquivarAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  verificarAprovacaoAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_VERIFICAR_APROVACAO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "FALHA":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('verificarAprovacaoAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  aprovarAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_APROVAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('aprovarAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  desaprovarAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_DESAPROVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('desaprovarAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  calcularFinalizacao(context, payload) {
    return axios.post(URLS.ALUGUEIS_CALCULAR_FINALIZACAO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
        case "FALHA":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('calcularFinalizacao', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  finalizarContratoConcluido(context, payload) {
    return axios.post(URLS.ALUGUEIS_FINALIZAR_CONCLUIDO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "FALHA":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('finalizarContratoConcluido', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  finalizar(context, payload) {
    return axios.post(URLS.ALUGUEIS_FINALIZAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "FALHA":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('finalizar', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  finalizarComRestricoes(context, payload) {
    return axios.post(URLS.ALUGUEIS_FINALIZAR_COM_RESTRICOES, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "FALHA":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('finalizarComRestricoes', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  cancelarFinalizacao(context, payload) {
    return axios.post(URLS.ALUGUEIS_CANCELAR_FINALIZACAO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
            context.commit('atualizarAluguelSelecionado', response.data.item);
            return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('cancelarFinalizacao', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  desocuparAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_DESOCUPAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('desocuparAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  cancelarDesocupacaoAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_CANCELAR_DESOCUPACAO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('cancelarDesocupacaoAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarClienteNovoAluguel(context, payload) {
    return axios.post(URLS.CLIENTES_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarClienteAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarClienteNovoAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarFiadorNovoAluguel(context, payload) {
    return axios.post(URLS.CLIENTES_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFiadorAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarFiadorNovoAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarMesSerieFinalizacao(context, payload) {
    return axios.post(URLS.ALUGUEIS_RECUPERAR_MES_SERIE_PARA_FINALIZACAO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarMesSerieFinalizacao', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarRecibosDescontoPorAcordo(context, payload) {
    return axios.post(URLS.ALUGUEIS_RECUPERAR_RECIBOS_DESCONTO_POR_ACORDO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarRecibosDescontoPorAcordo', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarDescontos(context, payload) {
    return axios.post(URLS.ALUGUEIS_GRAVAR_DESCONTOS, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          if(response.data.item) {
            context.commit('atualizarAluguelSelecionado', response.data.item);
          }
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarDescontos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarDescontosSaldoNegativo(context, payload) {
    return axios.post(URLS.ALUGUEIS_GRAVAR_DESCONTOS_SALDO_NEGATIVO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarDescontosSaldoNegativo', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerDesconto(context, payload) {
    return axios.post(URLS.ALUGUEIS_REMOVER_DESCONTO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
            context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerDesconto', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarEnvolvidos(context, payload) {
    return axios.post(URLS.ALUGUEIS_RECUPERAR_ENVOLVIDOS, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
            context.commit('atualizarClientesContrato', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarEnvolvidos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarLancamentoFuturo(context, payload) {
    return axios.post(URLS.ALUGUEIS_GRAVAR_LANCAMENTO_FUTURO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
            context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarLancamentoFuturo', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerLancamentoFuturo(context, payload) {
    return axios.post(URLS.ALUGUEIS_REMOVER_LANCAMENTO_FUTURO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
            context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerLancamentoFuturo', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  alterarDataVencimento(context, payload) {
    return axios.post(URLS.ALUGUEIS_ALTERAR_DATA_VENCIMENTO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('alterarDataVencimento', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  cancelarAlteracaoVencimento(context, payload) {
    return axios.post(URLS.ALUGUEIS_CANCELAR_ALTERACAO_VENCIMENTO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('cancelarAlteracaoVencimento', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gerarResumo(context, payload) {
    return axios.post(URLS.ALUGUEIS_EXIBIR_RESUMO_CONTRATO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarResumo', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  // REFATORAR - Store: RelatoriosAlugueis
  gerarRelatorio(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarRelatorio', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  // REFATORAR - Store: RelatoriosAlugueis
  enviarRelatorio(context, payload) {
    return axios.post(URLS.RELATORIOS_ENVIAR_POR_EMAIL, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('enviarRelatorio', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gerarDimob(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR_DIMOB, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarDimob', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  reajustarAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_REAJUSTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('reajustarAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  cancelarReajusteAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_CANCELAR_REAJUSTE, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('cancelarReajusteAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  renovarAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_RENOVAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('renovarAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  cancelarRenovacaoAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_CANCELAR_RENOVACAO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('cancelarRenovacaoAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  alterarRenovacaoAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_ALTERAR_RENOVACAO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('alterarRenovacaoAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  prorrogarAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_PRORROGAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('prorrogarAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  cancelarProrrogacaoAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_CANCELAR_PRORROGACAO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('cancelarProrrogacaoAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  alterarTaxaAdministracaoAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_ALTERAR_TAXA_ADMINISTRACAO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('alterarTaxaAdministracaoAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  ultimaTaxaAdministracaoComplementar(context, payload) {
    return axios.post(URLS.ALUGUEIS_ULTIMA_TAXA_ADM_COMPLEMENTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('ultimaTaxaAdministracaoComplementar', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  alterarValorAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_ALTERAR_VALOR_CONTRATO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('alterarValorAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  alterarCarenciaAluguel(context, payload) {
    return axios.post(URLS.ALUGUEIS_ALTERAR_CARENCIA_CONTRATO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('alterarCarenciaAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //VISTORIAS
  agendarVistoria(context, payload) {
    return axios.post(URLS.VISTORIAS_AGENDAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
        context.commit('atualizarAluguelSelecionado', response.data.item);
        return response.data;

        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('agendarVistoria', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  gerarFormularioVistoria(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR_VISTORIA, payload)
      .then((response) => {
        switch(response.data.status) {
          case 'SESSAO_EXPIRADA':
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('gerarFormularioVistoria', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },

  cancelarVistoriaAluguel(context, payload) {
    return axios.post(URLS.VISTORIAS_CANCELAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
        context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('cancelarVistoriaAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  removerVistoriaAluguel(context, payload) {
    return axios.post(URLS.VISTORIAS_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
        context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerVistoriaAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  forcarConclusaoVistoriaAluguel(context, payload) {
    return axios.post(URLS.VISTORIAS_FORCAR_CONCLUSAO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
        context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('forcarConclusaoVistoriaAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //RECUPERAR LISTAS
  listarUsuarios(context, payload) {
    return axios.post(URLS.USUARIOS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarUsuariosDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarUsuarios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarUsuariosDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarClientes(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarClientesDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarClientes', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarClientesDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  listarImoveis(context, payload) {
    return axios.post(URLS.IMOVEIS_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImoveisDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarImoveis', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarImoveisDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //FORMULÁRIOS
  criarDiretorioAluguel(context, payload) {
    return axios.post(URLS.FORMULARIOS_CRIAR_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('criarDiretorioAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  recuperarFormularios(context, payload) {
    return axios.post(URLS.FORMULARIOS_RECUPERAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarFormularios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  recuperarPerguntasFormulario(context, payload) {
    return axios.post(URLS.FORMULARIOS_RECUPERAR_PERGUNTAS, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarPerguntasFormulario', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  gerarFormularioAluguel(context, payload) {
    return axios.post(URLS.FORMULARIOS_GERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarFormularioAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerDiretorioAluguel(context, payload) {
    return axios.post(URLS.FORMULARIOS_REMOVER_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerDiretorioAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  selecionarDiretorioAluguel(context, payload) {
    return axios.post(URLS.FORMULARIOS_SELECIONAR_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('selecionarDiretorioAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //LOGS
  recuperarLogs(context, payload) {
    return axios.post(URLS.LOGGER_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarLogs', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarLogs', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //ARQUIVOS
  criarDiretorioArquivoAluguel(context, payload) {
    return axios.post(URLS.ARQUIVOS_CRIAR_DIRETORIO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarArquivos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('criarDiretorioArquivoAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  removerDiretorioArquivos(context, payload) {
    return axios.post(URLS.ARQUIVOS_REMOVER_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarArquivos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerDiretorioArquivos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  selecionarDiretorioArquivoAluguel(context, payload) {
    return axios.post(URLS.ARQUIVOS_SELECIONAR_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarArquivos', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('selecionarDiretorioArquivoImovelVenda', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  uploadArquivoAluguel(context, payload) {
    return axios.post(URLS.ARQUIVOS_UPLOAD, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('uploadArquivoAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  removerArquivo(context, payload) {
    return axios.post(URLS.ARQUIVOS_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerArquivo', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  //OBSERVAÇÕES
  recuperarObservacaoAluguel(context, payload) {
    return axios.post(URLS.OBSERVACOES_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarObservacaoAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarObservacaoAluguel(context, payload) {
    return axios.post(URLS.OBSERVACOES_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarObservacaoAluguel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerObservacao(context, payload) {
    return axios.post(URLS.OBSERVACOES_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerObservacao', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarBoletoAvulso(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("gravarBoletoAvulso", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  recuperarBoletoAvulso(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("recuperarBoletoAvulso", payload);
            }
          }).catch((error) => {
            throw error;
          });
      }
    }).catch((error) => {
      throw error;
    })
  },
  pagarBoletoAvulso(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_PAGAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('pagarBoletoAvulso', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  cancelarPagamentoBoletoAvulso(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_CANCELAR_PAGAMENTO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('cancelarPagamentoBoletoAvulso', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  prorrogarBoletoAvulso(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_PRORROGAR, payload).then(response => {
      switch(response.data.status) {
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true }).then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('prorrogarBoletoAvulso', payload)
            }
          }).catch(error => { throw error });
        
        case 'SUCESSO':
          context.state.aluguelSelecionado.boletosAvulsos = response.data.lista;
          return response.data;

        default:
          return response.data;
      }
    }).catch(error => { throw error });
  },
  calcularBoletoAvulso(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_CALCULAR, payload).then(response => {
      switch(response.data.status) {
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true }).then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('calcularBoletoAvulso', payload)
            }
          }).catch(error => { throw error });
        
        default:
          return response.data;
      }
    }).catch(error => { throw error });
  },
  cancelarProrrogacaoBoletoAvulso(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_CANCELAR_PRORROGACAO, payload).then(response => {
      switch(response.data.status) {
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true }).then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('cancelarProrrogacaoBoletoAvulso', payload)
            }
          }).catch(error => { throw error });
        
        case 'SUCESSO':
          context.state.aluguelSelecionado.boletosAvulsos = response.data.lista;
          return response.data;
        
        default:
          return response.data;
      }
    }).catch(error => { throw error });
  },
  removerBoletoAvulso(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_REMOVER, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerBoletoAvulso', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  gerarLaudoVistoria(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR_LAUDO_VISTORIA, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("gerarLaudoVistoria", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  enviarLaudoVistoria(context, payload) {
    return axios.post(URLS.RELATORIOS_ENVIAR_LAUDO_VISTORIA, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("enviarLaudoVistoria", payload)
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarBoletosAvulsos(context, payload) {
    return axios.post(URLS.BOLETOS_AVULSOS_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarBoletosAvulsos', response.data.lista)
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('recuperarBoletosAvulsos', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  removerCobrancasDoRecibo(context, payload) {
    return axios.post(URLS.ALUGUEIS_REMOVER_COBRANCAS_RECIBO, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('removerCobrancasDoRecibo', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  removerRegistrosDoContrato(context, payload) {
    return axios.post(URLS.ALUGUEIS_REMOVER_REGISTRO_RECIBOS_CONTRATO, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('removerRegistrosDoContrato', payload);
            }
          }).catch(error => {
            throw error;
          });
        default: 
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  retomarVistoria(context, payload) {
    return axios.post(URLS.VISTORIAS_RETOMAR, payload)
    .then(response => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('retomarVistoria', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  trocarTitularidadeProprietario(context, payload) {
    return axios.post(URLS.ALUGUEIS_TROCAR_TITULARIDADE_PROPRIETARIO, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('trocarTitularidadeProprietario', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  trocarTitularidadeLocatario(context, payload) {
    return axios.post(URLS.ALUGUEIS_TROCAR_TITULARIDADE_LOCATARIO, payload)
    .then(response => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarAluguelSelecionado', response.data.item);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('trocarTitularidadeLocatario', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}